const removeWhiteSpace = (string: string): string => {
	return string.replace(/\s+/g, ' ').trim()
}

export const getNameAndLastName = (fullName: string): [string, string] => {
	const treatedFullName = removeWhiteSpace(fullName)
	const [firstName, ...lastName] = treatedFullName.split(' ')
	return [firstName, lastName.join(' ')]
}
